module.exports = __webpack_public_path__ + "static/condo-5-3438e4f993329623aa7f84a2e33b935b.jpg";